import React, { useMemo, useState } from 'react'
import { CustomSheetContent, Sheet, SheetClose, SheetTrigger } from '../ui/sheet'
import { Search, X } from 'lucide-react'
import dynamic from 'next/dynamic'
import { useTypingAnimation } from './trip-search-bar'
import { CustomMapPin } from '../icons/custom-map-pin'

// Dynamically import TripSearchBar
const DynamicTripSearchBar = dynamic(
    () => import('./trip-search-bar').then(mod => mod.default),
    {
        loading: () => (
            <div className="animate-pulse size-9 rounded-full md:h-9 md:w-52 md:rounded-md bg-gray-200" />
        ),
        ssr: false // Optional: set to false if this component doesn't need server-side rendering
    }
)

export default function SearchTrigger() {
    const [isOpen, setIsOpen] = useState(false)

    const suggestions = useMemo(() => [
        'Malvan', 'Hampi', 'Gokarna', 'Goa', 'Pondicherry', 'Manali', 'Kedarnath', 'Rishikesh', 'Murudeshwar',
        'Uttarakhand', 'Kerala', 'Tamilnadu', 'Sahyadri Treks', 'Dwarka Somnath', 'Rann of Kutch', 'Ujjain Omkareshwar',
        'Spiti Valley', 'Ladakh', 'Rajasthan'
    ], []);

    const word = useTypingAnimation(suggestions, 2000, 100);

    return (
        <Sheet open={isOpen} onOpenChange={setIsOpen}>
            <SheetTrigger>
                <>
                    <div className='hidden sm:flex justify-between items-center gap-2 relative h-9 w-52 px-2.5 bg-gradient-to-r from-[#024a74] to-[#1573AB] rounded-md group cursor-pointer text-sm font-medium text-white text-nowrap overflow-hidden text-ellipsis'>
                        <span className='flex items-center gap-1'>
                            <CustomMapPin className='size-4 shrink-0 text-white' strokeWidth={1.5} />
                            {word}
                        </span>
                        <span className='shrink-0 border-l border-white/40 pl-2'>
                            <Search className='size-4' strokeWidth={1.5} />
                        </span>
                    </div>
                    <div className='sm:hidden flex gap-2 relative size-9 rounded-full p-1.5 group cursor-pointer'>
                        <span className='absolute top-0 left-0 h-full w-full bg-custom-primary lg:scale-0 lg:group-hover:scale-100 transition duration-500 rounded-full' />
                        <Search className='h-full w-full text-white relative' />
                    </div>
                </>
            </SheetTrigger>
            <CustomSheetContent side={'top'} className='pt-0 md:p-0 h-fit w-full'>
                <div className='h-24 md:h-32 lg:pb-6 xl:pb-4 w-full flex flex-nowrap gap-6 justify-center items-center'>
                    {isOpen && (
                        <DynamicTripSearchBar
                            btnName='Search'
                            className='border border-secondary-text bg-white text-black'
                        />
                    )}
                    <SheetClose asChild>
                        <div className='bg-white text-black border border-secondary-text rounded-md h-10 w-10 p-1.5 lg:h-12 lg:w-12 lg:p-2.5 mt-5 cursor-pointer hidden md:block'>
                            <X className='h-full w-full' strokeWidth={1.6} />
                        </div>
                    </SheetClose>
                </div>
            </CustomSheetContent>
        </Sheet>
    )
}